import AppraisalApi from './AppraisalApi';
import AppraisalBffApi from './AppraisalBffApi';
import VehicleBffApi from './VehicleBffApi';

const Api = {
  appraisal: AppraisalApi,
  appraisalBff: AppraisalBffApi,
  vehicleBff: VehicleBffApi
};

export default Api;
